// eslint-disable-next-line import/prefer-default-export
export enum PersonalizationChannels {
  Shopify = 'shopify',
  Etsy = 'etsy',
}
